import { Category } from "components/common"
import { TREASURES } from "lib/tools/categories"
import { baseTreasure } from "components/common/skeleton"
import SkeletonLink from "components/common/skeleton-link"
import { useRouter } from "next/router"
import isBrowser from "lib/tools/is-browser"
import { useTranslation } from "lib/i18n/translation"
import { useCountry } from "lib/country"
import { get, replace } from "lib/redirects"

import image, { CATEGORY_LOGO_LARGE } from "lacinetek-common/src/images"
import Image from "components/common/image"

export default ({ }) => {
	const router = useRouter()

	return (
		<Category
			category={TREASURES}
			light={true}
			renderLoading={() => (
				<Content treasures={[baseTreasure, baseTreasure, baseTreasure, baseTreasure, baseTreasure]} loading={true} path={isBrowser ? router.asPath : ""} />
			)}
		>
			{({ children, loading }) => (
				<Content treasures={children.items} path={isBrowser ? router.asPath : ""} />
			)}
		</Category>
	)
}

const Content = ({ treasures }) => {
	const { c } = useTranslation("common")
	const { asPath } = useCountry()

	return (
		<nav className="contextual filters institutions relative" aria-label={c("treasures-contextual-navigation")}>
			{treasures.map((treasure, index) => {
				const target = "/tresors-caches/[id]"
				const realTarget = get(target)

				return (
					<SkeletonLink
						key={`treasure-link-${index}`}
						href={target}
						as={replace(realTarget, treasure.linkRewrite)}
						passHref
					>
						<a
							title={treasure.name}
							className={asPath.includes(treasure.linkRewrite) ? "active" : ""}
							aria-current={asPath.includes(treasure.linkRewrite) ? "true" : ""}
						>
							<figure>
								<picture>
									<Image src={image(treasure, CATEGORY_LOGO_LARGE)} alt={treasure.name} />
								</picture>
							</figure>
						</a>
					</SkeletonLink>
				)
			})}
		</nav>
	)
}
